.wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.announcement {
  margin: 0;
  font-size: 0.875rem;
  color: var(--text-muted);
}
